import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import Button from '@spa/shared/components/Unisystem/Button';
import ArrowBack from '@spa/shared/svg/arrow-back';
import ArrowNext from '@spa/shared/svg/arrow-next';
import { Wrapper } from './styles';

const SHOW_BUTTONS = {
  show_more: (t, onClick) => (
    <Button icon={ArrowNext} iconSide="right" isGhost onClick={onClick}>
      {t('Show more')}
    </Button>
  ),
  show_less: (t, onClick) => (
    <Button icon={ArrowBack} iconSide="left" isGhost onClick={onClick}>
      {t('Show less')}
    </Button>
  )
};

const ReadMoreInline = ({ text, maxLines = 4 }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [showMore, setShowMore] = useState(null);

  const toggleShowMore = () => setShowMore(!showMore);

  useEffect(() => {
    const descriptionText = ref.current.querySelector('p');
    const lineHeight = parseFloat(getComputedStyle(descriptionText).lineHeight);
    const maxHeight = lineHeight * maxLines;

    const isOverflowing = descriptionText.scrollHeight > maxHeight;
    if (isOverflowing) {
      setShowMore(isOverflowing);
    }
  }, [text]);

  return (
    <Wrapper ref={ref} showMore={showMore} maxLines={maxLines}>
      <p>{text}</p>
      {showMore !== null && SHOW_BUTTONS[showMore ? 'show_more' : 'show_less'](t, toggleShowMore)}
    </Wrapper>
  );
};

ReadMoreInline.propTypes = {
  text: PropTypes.string.isRequired,
  maxLines: PropTypes.number,
  showLess: PropTypes.bool
};

export default ReadMoreInline;
